import type { LenderListState } from '@makemydeal/dr-dash-types';

/**
 * US2053560 — Ford Motor Credit and Lincoln Automotive Financial Services are hard-coded into the
 * Contracting Lender dropdown for dealers with the `US2053560_Enable_Ford_Lincoln_Lenders`
 * app-config toggle enabled.
 *
 */
export const HARDCODED_CONTRACTING_LENDERS: LenderListState = [
    { lenderId: 'FMX', lenderName: 'Ford Motor Credit', lenderLogo: '' },
    { lenderId: 'LAX', lenderName: 'Lincoln Automotive Financial Services', lenderLogo: '' }
];

/**
 * Appends the hard-coded contracting lenders to the dealer's lender list, skipping any that
 * are already present (matched case-insensitively by name, or by id).
 */
export const appendHardcodedContractingLenders = (lenderList: LenderListState): LenderListState => {
    const existingIds = new Set(lenderList.map((lender) => lender.lenderId));
    const existingNames = new Set(lenderList.map((lender) => lender.lenderName.toLowerCase()));

    const lendersToAppend = HARDCODED_CONTRACTING_LENDERS.filter(
        (lender) => !existingIds.has(lender.lenderId) && !existingNames.has(lender.lenderName.toLowerCase())
    );

    return lendersToAppend.length ? [...lenderList, ...lendersToAppend] : lenderList;
};
